import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/joy';
import { supabase } from '../supabaseClient';
import dayjs from 'dayjs';

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(true);
      const now = new Date().toISOString();

      const { data, error } = await supabase
        .from('announcements')
        .select('id, title, body, created_at, expires_at')
        .or(`expires_at.is.null,expires_at.gt.${now}`)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching announcements:', error.message);
      } else {
        setAnnouncements(data);
      }

      setLoading(false);
    };

    fetchAnnouncements();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      {announcements.slice(0, 3).map((a) => (
        <Box
          key={a.id}
          sx={{
            mb: 2,
            p: 2,
            border: '1px solid',
            borderColor: 'neutral.outlinedBorder',
            borderRadius: 'md',
            backgroundColor: 'background.surface',
          }}
        >
          <Typography level="title-md">{a.title}</Typography>
          <Typography level="body-sm" color="neutral" sx={{ mt: 0.5 }}>
            {dayjs(a.created_at).format('MMMM D, YYYY')}
          </Typography>
          <Typography level="body-md" sx={{ mt: 1 }}>
            {a.body}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Announcements;